export const getDeviceTimezone = (): string => {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return timezone || 'UTC';
};

export const getDeviceTimezoneOffset = (): string => {
  // getTimezoneOffset() is minutes behind UTC; negate to get conventional UTC±HH:mm sign.
  const offsetMinutes = -new Date().getTimezoneOffset();
  const sign = offsetMinutes >= 0 ? '+' : '-';
  const absoluteMinutes = Math.abs(offsetMinutes);
  const hours = Math.floor(absoluteMinutes / 60)
    .toString()
    .padStart(2, '0');
  const minutes = (absoluteMinutes % 60).toString().padStart(2, '0');

  return `${sign}${hours}:${minutes}`;
};
